import type { App } from "vue";

export const vaporAssetPlugin = {
  install(app: App): void {
    app.config.globalProperties.$asset = (path: string ) => (import.meta.env.VITE_VAPOR_ASSET_URL ?? '') + '/' + path;
  },
};
